export const alertConstants = {
  SHOW_ALERT: 'SHOW_ALERT',
  CLEAR_ALERT: 'CLEAR_ALERT',
}
